import React, { useState } from 'react';
import PropTypes from 'prop-types';
import encode from 'urlencode';

import { StyledBox, StyledContainer, StyledLoader } from './styles';

export const VpDocViewer = ({ document }) => {
  const docUrl = encode(document?.previewUrl);
  const contentType = document?.contentType;
  const [isLoading, setIsLoading] = useState(true);

  const onLoad = () => {
    setIsLoading(false);
  };

  const docSrc =
    contentType === 'application/pdf' || contentType === 'text/html' || contentType === 'text/plain'
      ? `${document?.previewUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0`
      : `https://view.officeapps.live.com/op/embed.aspx?src=${docUrl}`;

  return (
    <StyledContainer>
      {isLoading && <StyledLoader size={60} />}
      <StyledBox onLoad={onLoad} component="iframe" src={docSrc}></StyledBox>
    </StyledContainer>
  );
};

VpDocViewer.propTypes = {
  document: PropTypes.object
};

export default VpDocViewer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDocViewer/VpDocViewer.jsx